<template>
  <div class="admin-login-log-container">
    <div class="header-toolbar">
      <h2>客户登录日志</h2>
      <div>
        <el-button type="info" @click="goBack" style="margin-right: 10px">返回订单管理</el-button>
      </div>
    </div>

    <div class="search-bar" style="margin-bottom: 20px">
      <el-input
        v-model="searchForm.username"
        placeholder="输入用户名搜索"
        style="width: 220px; margin-right: 10px"
      ></el-input>
      <el-select
        v-model="searchForm.success"
        placeholder="登录结果"
        clearable
        style="width: 160px; margin-right: 10px"
      >
        <el-option label="全部" :value="null"></el-option>
        <el-option label="成功" :value="1"></el-option>
        <el-option label="失败" :value="0"></el-option>
      </el-select>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button @click="handleReset" style="margin-left: 10px">重置</el-button>
    </div>

    <div class="table-container">
      <el-table
        :data="logList"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <el-table-column label="登录时间" prop="loginTime" width="200" align="center">
          <template slot-scope="scope">
            {{ scope.row.loginTime.replace("T", " ") }}
          </template>
        </el-table-column>
        <el-table-column label="用户名" prop="username" width="150" align="center"></el-table-column>
        <el-table-column label="客户编号" prop="customerNo" width="150" align="center"></el-table-column>
        <el-table-column label="角色" prop="role" width="130" align="center"></el-table-column>
        <el-table-column label="是否成功" width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.success === 1" type="success">成功</el-tag>
            <el-tag v-else type="danger">失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="结果信息" prop="message" align="left"></el-table-column>
      </el-table>
    </div>

    <div class="pagination" style="margin-top: 20px; text-align: right" v-if="total > 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { Message } from "element-ui";

export default {
  name: "AdminLoginLog",
  data() {
    return {
      logList: [],
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {
        username: "",
        success: null,
      },
    };
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    if (userInfo.role !== "admin" && userInfo.role !== "super_admin") {
      Message.error("无权限访问登录日志页面");
      this.$router.push("/login");
      return;
    }
    this.fetchLogs();
  },
  methods: {
    goBack() {
      this.$router.push("/admin-order-list");
    },
    fetchLogs() {
      if (this.loading) return;
      this.loading = true;
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      if (this.searchForm.username && this.searchForm.username.trim()) {
        params.username = this.searchForm.username.trim();
      }
      if (this.searchForm.success !== null && this.searchForm.success !== undefined) {
        params.success = this.searchForm.success;
      }
      request({
        url: "/api/loginLog/admin/page",
        method: "GET",
        params,
      })
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            this.logList = res.records || [];
            this.total = res.total || 0;
          } else {
            Message.error("获取登录日志失败：" + (res.msg || "未知错误"));
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error("获取登录日志失败:", err);
          Message.error("获取登录日志失败，请重试");
        });
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchLogs();
    },
    handleReset() {
      this.searchForm = { username: "", success: null };
      this.currentPage = 1;
      this.fetchLogs();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchLogs();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchLogs();
    },
  },
};
</script>

<style scoped>
.admin-login-log-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.header-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.search-bar {
  padding: 15px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.table-container {
  margin-bottom: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
</style>
